export interface MXmlJsonViewerProps {
  /** Raw XML or JSON string to display. Format is auto-detected. */
  content: string;
  /** Show a copy-to-clipboard button in the top-right corner. */
  copyable?: boolean;
  /** Show a markup/code icon alongside the format badge. */
  showFormatIcon?: boolean;
  /**
   * Fill the parent's width and wrap long lines. When false, the viewer sizes
   * to its content and long lines scroll horizontally instead.
   */
  wrap?: boolean;
}

export const mXmlJsonViewerDefaults = {
  copyable: true,
  showFormatIcon: true,
  wrap: true,
} satisfies Partial<MXmlJsonViewerProps>;
